module.exports = __webpack_public_path__ + "static/media/chart.b54a3b9f.svg";